import React, { useEffect } from 'react';
import { Container, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import moment from 'moment';
import { useNavigate, useParams } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { assignmentFeedback } from '../../atoms/AssignmentFeedbackState';
import ListHeader from '../../components/ListHeader';
import Pagination from '../../components/Pagination';
import ShowMore from '../../components/ShowMore';
import { assignmentFeedbacks } from '../../repositories/HttpRepository';
import SearchForm from './searchForm';
import useStyles from './styles';

const fields = [
  {
    id: 'driver_id',
    numeric: false,
    disablePadding: true,
    label: 'Driver ID',
    isDisableSort: true,
  },
  {
    id: 'driver_name',
    numeric: false,
    disablePadding: false,
    label: 'Driver Name',
    isDisableSort: true,
  },
  {
    id: 'assignment_id',
    numeric: false,
    disablePadding: false,
    label: 'Assignment Id',
    isDisableSort: true,
  },
  {
    id: 'is_like',
    numeric: false,
    disablePadding: false,
    label: 'Like/Dislike',
    isDisableSort: true,
  },
  {
    id: 'comment',
    numeric: false,
    disablePadding: false,
    label: 'Content',
    isDisableSort: true,
  },
  {
    id: '_created',
    numeric: false,
    disablePadding: false,
    label: 'Created date',
  },
];

const AssignmentFeedback = () => {
  const [feedbacks, setFeedbacks] = useRecoilState(assignmentFeedback);
  const { results, page, size, desc, order_by, total, isListing, search_text } = feedbacks;

  const navigate = useNavigate();
  const { classes } = useStyles();
  let { id } = useParams();

  const getList = (params) => {
    let queryParams = { size, page, search_text, order_by, desc };
    if (params) queryParams = { ...queryParams, ...params };

    assignmentFeedbacks(queryParams).then((resp) => {
      if (resp.ok) {
        const data = resp.data;
        setFeedbacks({
          ...feedbacks,
          results: data.results,
          page: data.from,
          size: data.size,
          total: data.total,
        });
      }
    });
  };

  useEffect(() => {
    getList();
  }, [search_text, order_by, desc, page]);

  const handleChangePage = (event, newPage) => {
    setFeedbacks({ ...feedbacks, page: newPage });
  };

  const handleRequestSort = (event, property) => {
    const isDesc = order_by === property && desc;
    setFeedbacks({ ...feedbacks, desc: !isDesc, order_by: property });
  };

  return (
    <Container maxWidth={false} className={classes.root}>
      <SearchForm initValue={search_text} placeholder="Search for assignment ID, driver ID, driver name " />
      <Paper className={classes.paper}>
        <TableContainer>
          <Table className={classes.table} aria-labelledby="tableTitle" aria-label="enhanced table">
            <ListHeader fields={fields} desc={desc} orderBy={order_by} onRequestOrder={handleRequestSort} rowCount={5} />
            <TableBody>
              {results &&
                results.map((item, index) => {
                  const labelId = `assignment-feedback-${index}`;
                  let likeStr = '---';
                  if (item.is_like === true) {
                    likeStr = 'LIKE';
                  }
                  if (item.is_like === false) {
                    likeStr = 'DISLIKE';
                  }
                  // console.log(item.assignment_id, item.is_like);
                  return (
                    <TableRow hover tabIndex={-1} key={item.id}>
                      <TableCell component="th" id={labelId} scope="row">
                        {item.driver_id}
                      </TableCell>
                      <TableCell>{item.driver_name}</TableCell>
                      <TableCell>{item.assignment_id}</TableCell>
                      <TableCell>{likeStr}</TableCell>
                      <TableCell>
                        <ShowMore text={item.comment} length={80} />
                      </TableCell>
                      <TableCell>{moment(item._created).format('DD MMM hh:mm A')}</TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
          {isListing && <LinearProgress />}
        </TableContainer>
        <Pagination total={total} size={size} onChange={handleChangePage} forceUpdatePage={page - 1} />
      </Paper>
    </Container>
  );
};
export default React.memo(AssignmentFeedback);
